import $ from 'jquery';
import config from './config';

export default class AgencyInfo {

    // Holds login and Agency information
    // Note that authorization check happens in map-googlemap.js. Look for "getToken()"
    constructor(lateLoading, applyData) {
        this.getFromSession()
    }

    //Must be called for the initialization of AgencyInfo. Otherwise will be invalid
    async init() {
        //Only need to make a request if agencies are not stored in the session
        // if (!this.agencies || !this.agenciesLookup || this.agenciesLookup.length === 0 || this.agencies.length === 0) {
        await $.ajax({
            type: 'GET',
            url: `${config.server}\\getagencies\\`,
            contentType: 'application/json',
            success: (data) => {
                //console.log(data);
                /* handle these two differently because on is array and one is dictionary
                *  Elliot Thompson 06/10/2021 */
                this.agencies = data.map((item) => {
                    return ({
                        key: item.Id,
                        value: item.Id,
                        label: `${item.Name} (${item.State.trim()})`,
                        state: item.State.trim(),
                        isSelected: false,
                        isSuperAdmin: item.IsSuperAdmin
                    });
                });
                for (let c of data) {
                    this.agenciesLookup[c.Id] = {

                        id: c.Id,
                        name: c.Name,
                        email: c.Email,
                        state: c.State,
                        type: c.Type,
                        lat: c.Lat,
                        long: c.Long
                    };
                }

                //Save things to session
                sessionStorage.setItem('agencies', JSON.stringify(this.agencies));
                sessionStorage.setItem('agencyLookup', JSON.stringify(this.agenciesLookup));
            },
        });
        // } else {
        //     console.log("session filled already");
        // }

    }

    getAgenciesDropdown() {
        //If agencies is empty, fetch from session
        if (this.agencies.length === 0) {
            this.getFromSession()
        }

        return this.agencies;
    }

    getAgencies() {
        //if lookup is empty, fetch from session
        if (this.agenciesLookup.length === 0) {
            this.getFromSession()
        }
        return this.agenciesLookup;
    }
    getSelectedAgencyId() {
        //if agencyID is null, fetch from session
        if (this.agencyId === undefined || this.agencyId === 'null') {
            this.getFromSession()
        }
        return this.agencyId;
    }

    getSelectedAgencyData() {
        return this.getAgencies()[this.getSelectedAgencyId()];
    }

    setAgencies(id) {
        this.agencyId = id;
    }

    getSelectedAgencyLat() {
        return parseFloat(this.getAgencies()[this.getSelectedAgencyId()]['lat']);
    }
    getSelectedAgencyLong() {
        return parseFloat(this.getAgencies()[this.getSelectedAgencyId()]['long']);
    }

    getFromSession() {
        //Fetch entries from session
        var jsn = JSON.parse(sessionStorage.getItem('token'))
        if (jsn !== null) {
            this.agencyId = jsn.id;
            this.loggedIn = jsn.logged
        }
        // do not make these '==' into '===', else the program will crash on a null error
        this.agencies = (sessionStorage.getItem('agencies') == undefined ? [] : JSON.parse(sessionStorage.getItem('agencies'))) || [];
        this.agenciesLookup = (sessionStorage.getItem('agencyLookup') == undefined ? [] : JSON.parse(sessionStorage.getItem('agencyLookup'))) || [];
    }

    getToken() {
        return JSON.parse(sessionStorage.getItem('token'))
    }

}


// WEBPACK FOOTER //
// ./src/AgencyInfo.js